// CertificateReadyRow — one row for the dashboard's "Certificates ready"
// card. Issuing uses the same useIssueCertificate hook as the
// CertificatesPage's "Ready to issue" table.
import { useIssueCertificate } from "../../hooks/useIssueCertificate.js";
import Avatar from "../shared/Avatar.js";
import type { CertificateReady } from "../../lib/adminDashboardTypes.js";

interface CertificateReadyRowProps {
  item: CertificateReady;
  onIssued: () => void;
}

export default function CertificateReadyRow({ item, onIssued }: CertificateReadyRowProps) {
  const { isSubmitting, error, issue: issueCert } = useIssueCertificate(item.studentId, item.courseId, onIssued);

  return (
    <li className="py-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <Avatar name={item.studentName} />
          <div className="min-w-0">
            <p className="truncate text-sm font-medium text-dm-navy">{item.studentName}</p>
            <p className="truncate text-xs text-dm-slate">{item.courseTitle}</p>
          </div>
        </div>
        <button
          type="button"
          disabled={isSubmitting}
          onClick={() => void issueCert()}
          className="shrink-0 rounded-md bg-dm-navy px-2.5 py-1 text-xs font-medium text-white hover:bg-dm-blue disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isSubmitting ? "Issuing…" : "Issue cert"}
        </button>
      </div>
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </li>
  );
}
